import { Fragment } from 'react'
import { navigateOwner, type OwnerRoute } from '../ownerRouter'
import { useNls } from '../../../nls/nlsProvider'

export type BreadcrumbItem = {
  label: string
  targetRoute?: OwnerRoute
}

export const OwnerBreadcrumb = ({ route }: { route: OwnerRoute }) => {
  const { t } = useNls()

  const crumbs: BreadcrumbItem[] = [
    { label: t('NLSOwnerConsoleNavHome'), targetRoute: { view: 'home' } },
  ]

  switch (route.view) {
    case 'home':
      break
    case 'workspaces':
      crumbs.push({ label: t('NLSOwnerConsoleGroupPeopleWorkspaces') })
      crumbs.push({ label: t('NLSOwnerConsoleNavWorkspaces') })
      break
    case 'workspace-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupPeopleWorkspaces') })
      crumbs.push({ label: t('NLSOwnerConsoleNavWorkspaces'), targetRoute: { view: 'workspaces' } })
      crumbs.push({ label: route.workspaceId })
      break
    case 'people':
      crumbs.push({ label: t('NLSOwnerConsoleGroupPeopleWorkspaces') })
      crumbs.push({ label: t('NLSOwnerConsoleNavPeople') })
      break
    case 'person-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupPeopleWorkspaces') })
      crumbs.push({ label: t('NLSOwnerConsoleNavPeople'), targetRoute: { view: 'people' } })
      crumbs.push({ label: route.userId })
      break
    case 'inbox':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavInbox') })
      break
    case 'ticket-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavInbox'), targetRoute: { view: 'inbox' } })
      crumbs.push({ label: `#${route.ticketId}` })
      break
    case 'feedback':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavFeedback') })
      break
    case 'feedback-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavFeedback'), targetRoute: { view: 'feedback' } })
      crumbs.push({ label: route.surveyId })
      break
    case 'broadcast':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavBroadcast') })
      break
    case 'broadcast-new':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavBroadcast'), targetRoute: { view: 'broadcast' } })
      crumbs.push({ label: 'New' })
      break
    case 'broadcast-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupSupport') })
      crumbs.push({ label: t('NLSOwnerConsoleNavBroadcast'), targetRoute: { view: 'broadcast' } })
      crumbs.push({ label: route.broadcastId })
      break
    case 'ops':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavOps') })
      break
    case 'incident-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavOps'), targetRoute: { view: 'ops' } })
      crumbs.push({ label: route.incidentId })
      break
    case 'logs':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavLogs') })
      break
    case 'logs-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavLogs'), targetRoute: { view: 'logs' } })
      crumbs.push({ label: route.logId })
      break
    case 'analytics':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavAnalytics') })
      break
    case 'revenue':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavRevenue') })
      break
    case 'costs':
      crumbs.push({ label: t('NLSOwnerConsoleGroupHealth') })
      crumbs.push({ label: t('NLSOwnerConsoleNavCosts') })
      break
    case 'config-settings':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavSettings') })
      break
    case 'config-flags':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavFlags') })
      break
    case 'config-flag-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavFlags'), targetRoute: { view: 'config-flags' } })
      crumbs.push({ label: route.flagKey })
      break
    case 'config-cohorts':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavCohorts') })
      break
    case 'config-cohort-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavCohorts'), targetRoute: { view: 'config-cohorts' } })
      crumbs.push({ label: route.cohortId === 'new' ? t('NLSOwnerConsoleCohortsCreateTitle') : route.cohortId })
      break
    case 'config-economy':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavEconomy') })
      break
    case 'config-plan-limits':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavPlanLimits') })
      break
    case 'config-templates':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavTemplates') })
      break
    case 'config-template-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavTemplates'), targetRoute: { view: 'config-templates' } })
      crumbs.push({ label: route.templateId })
      break
    case 'config-feedback-authoring':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavFeedbackAuthoring') })
      break
    case 'config-feedback-authoring-detail':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavFeedbackAuthoring'), targetRoute: { view: 'config-feedback-authoring' } })
      crumbs.push({ label: route.surveyId })
      break
    case 'config-experience-engine':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavExperienceEngine') })
      break
    case 'config-moderation':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavModeration') })
      break
    case 'config-actions':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavActions') })
      break
    case 'config-integrations':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavIntegrations') })
      break
    case 'config-demo-lane':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavDemoLane') })
      break
    case 'config-client-outreach':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleNavClientOutreach') })
      break
    case 'config-line':
      crumbs.push({ label: t('NLSOwnerConsoleGroupConfig') })
      crumbs.push({ label: t('NLSOwnerConsoleLineTab') })
      break
    case 'activity':
      crumbs.push({ label: t('NLSOwnerConsoleNavActivity') })
      break
    case 'activity-detail':
      crumbs.push({ label: t('NLSOwnerConsoleNavActivity'), targetRoute: { view: 'activity' } })
      crumbs.push({ label: route.actionId })
      break
  }

  return (
    <nav className="ownerBreadcrumb" aria-label="Owner breadcrumb">
      {crumbs.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1
        return (
          <Fragment key={`${crumb.label}-${idx}`}>
            {idx > 0 && <span className="ownerBreadcrumbSeparator">/</span>}
            {isLast || !crumb.targetRoute ? (
              <span className={`ownerBreadcrumbCrumb ${isLast ? 'ownerBreadcrumbCrumb--current' : ''}`}>
                {crumb.label}
              </span>
            ) : (
              <button
                type="button"
                className="ownerBreadcrumbCrumb"
                onClick={() => crumb.targetRoute && navigateOwner(crumb.targetRoute)}
              >
                {crumb.label}
              </button>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
